import { json, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { noopSanitizeJSON } from "../utils";
import { Markup } from "@towersystems/roam-common/lib/generated-types";

export default class Department extends BaseModel {
  static table = "departments";
  @text("name") name: string;
  @text("description") description: string | null;
  @json("markup", noopSanitizeJSON) markup?: Markup[];
  @text("preferred_tax_group_id") preferredTaxGroupId: string | null;
}
